var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('multi-selectbox',{class:_vm.validateError != '' ? 'box-border-color':'',attrs:{"options":_vm.computedOptions,"disabled":_vm.disabled,"validate-error":_vm.validateError,"multiple":false},on:{"input":_vm.handleInput},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }